export const DTI_RATIO_ASSESSMENT_MAP = {
  maximum: 'maximum',
  high: 'high',
  medium: 'medium',
  low: 'low',
}
